<div class="previous-discussions-modal-container" data-test-id="history-modal">
  <div class="header-container">
    <h2 mat-dialog-title>Previous Discussions</h2>
    <button class="x-icon" (click)="dialogRef.close()" role="button" tabindex="0" aria-label="Close dialog">x</button>
  </div>
  <mat-divider></mat-divider>
  <div class="content-container">
    <div *ngFor="let conversationHistory of history; let i = index">
      <button
        class="discussion-card"
        (click)="selectConversation(conversationHistory)"
        aria-label="Select conversation"
        tabindex="0"
        [attr.aria-posinset]="i + 1"
        [attr.aria-setsize]="history.length">
        <div class="left">
          <p>{{ conversationHistory.latest_prompt_time | LocalDate }}</p>
          <div class="summary">
            <p>
              {{ conversationHistory.title | slice: 0 : 300 }}
            </p>
          </div>
        </div>
        <div class="right">
          <mat-icon>chevron_right</mat-icon>
        </div>
      </button>
      <mat-divider></mat-divider>
    </div>
    <div *ngIf="history.length === 0" class="no-history">
      <p>No previous discussions found.</p>
    </div>
  </div>
</div>
